<template>
  <div data-qa="errorhandler-div-14ml4d">
    <component
      v-if="config.component"
      :is="config.component"
      :config="getSettings()"
    ></component>
  </div>
</template>

<script>
export default {
  name: 'dob-errorHandler',
  components: {
    'dob-snackbar': () => import('@/components/DOB-Snackbar/DobSnackbar.vue'),
    'dob-modal': () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      settingsObj: {
        'dob-snackbar': {
          snackbar: {
            visible: true,
            text: '',
            timeout: 4000,
            color: '',
            title: ''
          }
        },
        'dob-modal': {
          enabled: false,
          name: 'dob',
          values: '',
          btn1Label: 'OK',
          close: true,
          title: '',
          'max-height': '50px',
          width: '',
          persistent: false
        }
      },
      colorMap: {
        error: {
          color: '#E57373'
        },
        success: {
          color: '#66BB6A' // green lighten-1
        }
      }
    }
  },
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    getColorByType (messageType) {
      return this.colorMap[messageType].color
    },
    getSettings () {
      const {
        content, type, title, component,
        saveButton, cancelButton, timeout, width, saveCallback, cancelCallback, close, persistent, icon, outlinedSaveBtn, outlinedCancelBtn
      } = this.config
      const settingObj = this.settingsObj[component]
      const getColorCode = this.getColorByType(type)

      settingObj.enabled = true

      if (component === 'dob-modal') {
        settingObj.icon = icon
        settingObj.close = close
        settingObj.title = title
        settingObj.values = content
        settingObj.persistent = persistent
        settingObj.saveButton = saveButton
        settingObj.cancelButton = cancelButton
        settingObj.saveCallback = saveCallback
        settingObj.cancelCallback = cancelCallback
        settingObj.outlinedSaveBtn = outlinedSaveBtn
        settingObj.outlinedCancelBtn = outlinedCancelBtn
        settingObj.width = width || '400px'
      } else if (component === 'dob-snackbar') {
        settingObj.snackbar.text = content
        settingObj.snackbar.color = type
        settingObj.snackbar.visible = true
      }
      return settingObj
    }
  }
}
</script>
